import { BooleanFilterEnum } from '../../../shared/enums/boolean-filter.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { LocationStatusEnum } from '../enums/location-status.enum';
import { LocationTypeEnum } from '../enums/location-type.enum';

/**
 * Location filters
 */
export class LocationsFilters extends ApiRequestFilters {
  /**
   * Country id values
   */
  countries?: number[];

  /**
   * Status values
   */
  statuses?: LocationStatusEnum[];

  /**
   * Type values
   */
  types?: LocationTypeEnum[];

  /**
   * Tag id values
   */
  tags?: number[];

  /**
   * Filter by pickup eligibility
   */
  isPickUp?: BooleanFilterEnum;

  /**
   * Filter by dropoff eligibility
   */
  isDropOff?: BooleanFilterEnum;
}
